module.exports = __webpack_public_path__ + "img/img-hyf-3.a67d2fb1.png";